"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardOrderLine = void 0;
const enums_1 = require("../../enums");
const product_dashboard_order_line_product_response_1 = require("./product-dashboard-order-line-product.response");
const product_dashboard_sales_order_release_response_1 = require("./product-dashboard-sales-order-release.response");
const product_dashboard_sales_order_response_1 = require("./product-dashboard-sales-order.response");
class ProductDashboardOrderLine {
}
exports.ProductDashboardOrderLine = ProductDashboardOrderLine;
//# sourceMappingURL=product-dashboard-order-line.response.js.map